module.exports = __webpack_public_path__ + "img/amazonia.6dc0ef6c.png";